import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import standingsReducer from 'screens/standingsScreen/state/standingsReducer';

const store = (createStore)(
  standingsReducer,
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk)
);
 
export default store;


// WEBPACK FOOTER //
// ./src/store.js